// Module
var code = "<div data-bind=\"style: {height: fullHeight ? '100%' : '1em'}\">\n    <span class=\"bar\" data-bind=\"style: {width: percentStr}\"></span>\n    <span class=\"label\" data-bind=\"text: percentStr, css: {gt50: percent() > 50}\"></span>\n</div>\n";
// Exports
export default code;